import { render, staticRenderFns } from "./throughRecords.vue?vue&type=template&id=7b731f15&scoped=true"
import script from "./throughRecords.vue?vue&type=script&lang=js"
export * from "./throughRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b731f15",
  null
  
)

export default component.exports